import axiosConfig from "../axiosConfig.js";
import { toast } from "react-toastify";

class PatientService {
    getAllInsuranceProvider = async () => {
        try {
            const response = await axiosConfig.get("scheduling/insuranceProvider/GetAll");
            return response;
        } catch (error) {
            const errorMessage = error?.message || "insurance Provider not get"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    getDoctors = async (requestBody, accessToken) => {
        try {
            const response = await axiosConfig.post("scheduling/getDoctors", requestBody);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "getDoctors not get"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    getTopDoctors = async () => {
        try {
            const response = await axiosConfig.get("scheduling/topDoctors");
            return response;
        } catch (error) {
            const errorMessage = error?.message || "getDoctors not get"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    getDoctorDetails = async (id) => {
        try {
            const response = await axiosConfig.get("scheduling/getDoctorDetails/" + id);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "No doctor details"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    getDoctorAvailability = async (requestBody) => {
        try {
            const response = await axiosConfig.post("scheduling/GetDoctorAvailability", requestBody);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "No doctor availability"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    getNotAvailableDates = async (requestBody) => {
        try {
            const response = await axiosConfig.post("scheduling/GetNotAvailableDates", requestBody);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Get Not AvailableDates"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            // throw new Error(error);
        }
    };
    bookVisit = async (requestBody, accessToken) => {
        try {
            const response = await axiosConfig.post("scheduling/bookVisit", requestBody);
            return response;

        } catch (error) {
            const errorMessage = error.message || "An error occurred while booking your visit. Please try again."; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            // throw new Error(error);
        }
    };

    getDoctorsWithSlots = async (requestBody, accessToken) => {
        try {
            const response = await axiosConfig.post("scheduling/GetDoctorsWithSlots", requestBody);
            return response;
        } catch (error) {
            const errorMessage = error.message || "GetDoctorsWithSlots not get";
            // toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };

    getIsQuestionNaireComplete = async (accessToken) => {
        try {
            const response = await axiosConfig.get("user/chat/isQuestionNaireComplete");
            return response;
        } catch (error) {
            const errorMessage = error.message || "GetDoctorsWithSlots not get";
            // toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    
    
}

const instance = new PatientService();

export default instance;
